import React from "react";
import { useNavigate } from "react-router-dom";
import { Hero } from "../components/Hero";
import { AboutSection } from "../components/AboutSection";
import { ProductSection } from "../components/ProductSection";
import { PartnersSection } from "../components/PartnersSection";
import { JourneySection } from "../components/JourneySection";
import { DealerCTA } from "../components/DealerCTA";
import { WhyChooseCromaSection } from "../components/WhyChooseCromaSection";
import { LeadershipSection } from "../components/LeadershipSection";
import { TestimonialsSection } from "../components/TestimonialsSection";

export const HomePage: React.FC = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate("/contact");
  };

  const handleProductsClick = () => {
    navigate("/products");
  };

  const handleIndividualProductClick = (productId: string) => {
    navigate(`/products/${productId}`);
  };

  const handleDistributorClick = () => {
    navigate("/distributor");
  };

  return (
    <div className="space-y-0">
      {/* Leadership and About sections with proper spacing */}
      <div className="relative z-0 lg:flex lg:flex-col">
        <div className="h-auto lg:h-[80vh]">
          <LeadershipSection />
        </div>
        <div className="lg:h-[40%] lg:overflow-auto">
          {/* <ScrollReveal delay={0.05}> */}
          <AboutSection />
          {/* </ScrollReveal> */}
        </div>
      </div>
      <WhyChooseCromaSection />
      <ProductSection
        onProductsClick={handleProductsClick}
        onLearnMoreClick={handleIndividualProductClick}
      />
      <Hero onContactClick={handleContactClick} />
      <div className="">
        {/* <ScrollReveal delay={0}> */}
        {/* <FeatureMarquee /> */}
        {/* </ScrollReveal> */}

        {/* <ScrollReveal delay={0.1}> */}
        {/* <AdvantageSection onProductsClick={handleProductsClick} /> */}
        {/* </ScrollReveal> */}
        {/* <ScrollReveal delay={0.1}> */}
        {/* <WhyChooseSection /> */}
        {/* </ScrollReveal> */}
        {/* <ScrollReveal delay={0.1}> */}
        <PartnersSection />
        {/* </ScrollReveal> */}
        <TestimonialsSection />
        {/* <ScrollReveal delay={0.1}> */}
        <div className="">
          <DealerCTA onFindDealerClick={handleDistributorClick} />
        </div>
        <JourneySection />
        {/* </ScrollReveal> */}
        {/* <ScrollReveal delay={0.1}> */}
        {/* <DealerCTA onFindDealerClick={handleDistributorClick} /> */}
        {/* </ScrollReveal> */}
        {/* <ScrollReveal delay={0.1}> */}
        {/* <BlogSection
          onExploreClick={handleBlogClick}
          onPostClick={handleBlogPostClick}
        /> */}
        {/* </ScrollReveal> */}
      </div>
    </div>
  );
};
